// extracted by mini-css-extract-plugin
module.exports = {"tabRow":"TabRow_tabRow__3Asy0"};